import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  borderRadius8,
  standardFocusState,
} from 'approot/shared/styles/borders.style';
import { grey1 } from 'approot/shared/styles/colours.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';

type SortableCardWrapperProps = {
  $isDragging: boolean;
};
export const SortableCardWrapper = styled.div<SortableCardWrapperProps>`
  background-color: ${grey1};
  border-radius: ${rem(borderRadius8)};
  position: relative;

  ${({ $isDragging }) =>
    $isDragging &&
    `
      opacity: 0;
  `}
`;

export const SortableCardContent = styled.div`
  position: relative;
`;

export const SortableCardDragLayer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: ${rem(40)};
  height: ${rem(40)};
  z-index: 100;

  &:hover {
    cursor: ns-resize;
  }
`;

export const SortableCardHandle = styled.div.attrs({
  tabIndex: 0,
  'aria-label': 'Use keyboard arrows to move up or down',
})`
  ${standardFocusState}
  ${flexCentreAlignCss}

  border-radius: ${rem(borderRadius8)};
  width: ${rem(32)};
  height: ${rem(32)};

  &:hover {
    cursor: grab;
  }
`;
